import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';

import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type saveData = {
    id?: any;
  };
  
  export const deleteUser = ({
   id
  }: saveData) => {
        return axios.delete(`/superAdmin/delete-institute/${id}`);
    
  };
  
  type UseAddPetOptions = {
    config?: MutationConfig<typeof deleteUser>;
  };
  
  export const useDeleteInstitute = ({ config }: UseAddPetOptions = {}) => {
    return useMutation({
      onSuccess: (res: any, req: any) => {
        showNotification({
          type: 'success',
          title: 'Institute deleted successfully.',
        });
      },
      ...config,
      mutationFn: deleteUser,
    });
  };
  
